import "./polyfills/legacyAt";
import { posthog } from "./instrument";

import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { PostHogProvider } from "@posthog/react";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>,
);

// Register SCORM service worker if supported
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const swUrl = "/sw-scorm.js";
    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        console.debug("[sw-scorm] Service Worker registered:", reg.scope);
      })
      .catch((err) => {
        console.debug("[sw-scorm] Service Worker registration failed:", err);
      });
  });
}
